import { Link } from 'react-router-dom';
import { ROUTES } from '../Routes'

const Footer = () => {
  const links = [
    { text: 'Terms', url: ROUTES.TERMS },
    { text: 'Privacy', url: ROUTES.PRIVACY },
    { text: 'Disclaimer', url: ROUTES.DISCLAIMER },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-section">
            <h4>Legal</h4>
            <p>
              Quinexa Virtual Entertainment<br />
              Social gaming platform<br />
              No real money involved
            </p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <div className="footer-links">
              {links.map((link, index) => (
                <Link key={index} to={link.url}>
                  {link.text}
                </Link>
              ))}

              <a href="/#chambers">Games</a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <p>
              Email: <a href="/cdn-cgi/l/email-protection" className="__cf_email__"
                data-cfemail="3c55525a537c4f5453595b5d51594f125f5351">info@quinexa.org</a><br />
              Address: Lentoportintie 3, Utti, 45410 Finland<br />
              Phone: + 010 7625000
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>2026 Quinexa. Social gaming entertainment, virtual Credits only, and no real-money rewards.</p>
          <p><strong>Notice:</strong> 18+ audience. No deposits, no withdrawals, and no cash-value credits.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;